var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "detail"
  }, [_c('v-breadcrumbs', {
    attrs: {
      "items": _vm.breadcrumbs
    }
  }), _vm.loading && !_vm.requestError ? _c('Loader', {
    attrs: {
      "content-id": _vm.addressID,
      "message": 'Fetching Address Details'
    }
  }) : _vm._e(), _vm.metadata && !_vm.requestError && _vm.assetsLoaded === true ? _c('AddressSummary', {
    attrs: {
      "meta-data": _vm.metadata,
      "address-i-d": _vm.addressID,
      "alias": _vm.alias,
      "assets": _vm.assets,
      "prefix": _vm.prefix
    }
  }) : _vm._e(), !_vm.loading && _vm.requestError ? _c('HTTPError', {
    attrs: {
      "id": _vm.addressID,
      "title": 'There was an error fetching address details.',
      "status": _vm.requestErrorStatus,
      "message": _vm.requestErrorMessage,
      "support-u-r-l": 'https://chat.avalabs.org'
    }
  }) : _vm._e(), !_vm.txRequestError ? _c('section', {
    staticClass: "card transactions"
  }, [_c('TxHeader'), _c('TxInteractive', {
    attrs: {
      "transactions": _vm.transactions,
      "assets-loaded": _vm.assetsLoaded,
      "loading": _vm.loading,
      "chains": _vm.chains
    },
    on: {
      "change": _vm.fetchTx
    }
  })], 1) : _vm._e(), !_vm.txLoading && _vm.txRequestError ? _c('HTTPError', {
    attrs: {
      "id": _vm.addressID,
      "title": 'There was an error fetching address transactions.',
      "status": _vm.txRequestErrorStatus,
      "message": _vm.txRequestErrorMessage,
      "support-u-r-l": 'https://chat.avalabs.org',
      "is-margin": true
    }
  }) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }